const ClientData01 = [
  {
    height: '50',
    img: "/images/nrnaplntpl9sxgenq4dx.webp",
    target: "_self",
    link: "https://www.worldbank.org/ext/en/home",
  },
  {
    height: '70',
    img: "/images/gb5qefver1fkmygb0w4e.webp",
    target: "_self",
    link: "https://keralaagriculture.gov.in/en/home/ ",
  },
  {
    height: '70',
    img: "/images/Picture1.webp",
    target: "_self",
    link: "https://industry.kerala.gov.in/",
  },
  {
    height: '70',
    img: "/images/Picture2.webp",
    target: "_self",
    link: "https://plantations.kerala.gov.in",
  },
  {
    height: '110',
    img: "/images/Picture3.webp",
    target: "_self",
    link: "https://www.kabco.co.in/",
  },
  {
    height: '110',
    img: "/images/Picture4.webp",
    target: "_self",
    link: "https://www.kau.in/",
  },
  {
    height: '110',
    img: "/images/Picture5.webp",
    target: "_self",
    link: "https://startupmission.kerala.gov.in/",
  },
  {
    height: '110',
    img: "/images/Picture6.webp",
    target: "_self",
    link: "https://kinfra.org/",
  },
  {
    height: '110',
    img: "/images/Picture7.webp",
    target: "_self",
    link: "https://www.irri.org/",
  },
  {
    height: '110',
    img: "/images/Picture8.webp",
    target: "_self",
    link: "https://www.nabard.org/",
  },
  {
    height: '110',
    img: "/images/Picture9.webp",
    target: "_self",
    link: "https://cwrdm.kerala.gov.in/",
  },
  {
    height: '110',
    img: "/images/Picture10.webp",
    target: "_self",
    link: "https://rubberboard.gov.in/",
  },
  {
    height: '70',
    img: "/images/Picture11.webp",
    target: "_self",
    link: "https://www.indianspices.com/",
  },
  {
    height: '110',
    img: "/images/Picture12.webp",
    target: "_self",
    link: "https://www.coffeeboard.gov.in/",
  },
  {
    height: '100',
    img: "/images/Picture13.webp",
    target: "_self",
    link: "https://www.vfpck.org/",
  }
];

const ClientData02 = [
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
];

const ClientData03 = [
  {
    img: "https://via.placeholder.com/400x160",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/400x160",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/400x160",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/400x160",
    target: "_self",
    link: "#",
  },
];

const ClientData04 = [
  {
    img: "https://via.placeholder.com/120x60",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/120x60",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/120x60",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/120x60",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/120x60",
    target: "_self",
    link: "#",
  },
];

const ClientData05 = [
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
];

const ClientData06 = [
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
];

const ClientData07 = [
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
  {
    img: "https://via.placeholder.com/232x110",
    target: "_self",
    link: "#",
  },
];

const ClientData08 = [
  {
    img: "https://via.placeholder.com/80x92",
  },
  {
    img: "https://via.placeholder.com/80x92",
  },
  {
    img: "https://via.placeholder.com/80x92",
  },
  {
    img: "https://via.placeholder.com/80x92",
  },
];

export {
  ClientData01,
  ClientData02,
  ClientData03,
  ClientData04,
  ClientData05,
  ClientData06,
  ClientData07,
  ClientData08,
};
